import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MenuItem } from 'src/app/models/rich-data.model';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-menu-section-item',
  templateUrl: './menu-section-item.component.html',
  styleUrls: ['./menu-section-item.component.scss']
})
export class MenuSectionItemComponent implements OnInit {

  @Input() item: MenuItem;
  @Output() itemClick: EventEmitter<MenuItem> = new EventEmitter<MenuItem>();

  showItem: boolean = true;

  constructor(
    private authService: AuthService
  ) { }

  ngOnInit() {
    this.updateVisibility();
  }

  private updateVisibility(): void {
    if (!this.authService.profile?.id) {
      this.showItem = true;
      return;
    }
      
    const {
      building_id: userBuildingId,
      area_id: userAreaId,
      block_id: userBlockId,
      floor_id: userFloorId,
      section_id: userSectionId,
    } = this.authService.profile.room_info;

    if (!this.item.menu_item_building_filter) {
      this.showItem = true;
      return;
    }

    switch (this.item.menu_item_building_filter.attribute_type) {
      case 1:
        this.showItem = this.item.menu_item_building_filter.attribute_ids.findIndex((id) => id === userAreaId) !== -1;
        break;
      case 2:
        this.showItem = this.item.menu_item_building_filter.attribute_ids.findIndex((id) => id === userBlockId) !== -1;
        break;
      case 3:
        this.showItem = this.item.menu_item_building_filter.attribute_ids.findIndex((id) => id === userFloorId) !== -1;
        break;
      case 4:
        this.showItem = this.item.menu_item_building_filter.attribute_ids.findIndex((id) => id === userSectionId) !== -1;
        break;
      default:
        this.showItem = true;
    }
  }

}
